// extracted by mini-css-extract-plugin
export default {"full":"productInfo_full__5n1Oo","card-item-wrapper":"productInfo_card-item-wrapper__xqKlq","action-wrapper":"productInfo_action-wrapper__rJwbz"};